import { NameSpacing } from '../../../../../../React/Common/Utils/NameSpacing'

export const GENERAL: string = 'details'
export const SCOPE_ASSIGNMENTS: string = 'scopeAssignment'
export const CONFIGURATION: string = 'configuration'

export enum GeneralTabFieldNames {
    CRMID = 'ID',
    DESCRIPTION = 'description'
}

export enum ScopeAssignmentTabFieldNames {
    CME = 'cme',
    TELEPHONY_SERVER = 'telephonyServer',
    PARTITION = 'partition',
    GROUP_DEVICE = 'groupDevice'
}

export enum ConfigurationTabFieldNames {
    CRM_TYPE = 'crmType',
    CRM_OPTIONS = 'crmOptions',
    TEMPLATE_TYPE = 'templateType'
}

export const CRMGeneralNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(GENERAL, fieldName)

export const CRMScopeAssignmentNameSpacing: (fieldName: string) => string = (fieldName: string): string =>
    NameSpacing(SCOPE_ASSIGNMENTS, fieldName)

export const GUID_GENERAL_NAME: string = CRMGeneralNameSpacing(GeneralTabFieldNames.CRMID)
export const DESCRIPTION_GENERAL_NAME: string = CRMGeneralNameSpacing(GeneralTabFieldNames.DESCRIPTION)

export const CME_SCOPE_NAME: string = CRMScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.CME)
export const TELEPHONY_SERVER_SCOPE_NAME: string = CRMScopeAssignmentNameSpacing(
    ScopeAssignmentTabFieldNames.TELEPHONY_SERVER
)
export const PARTITION_SCOPE_NAME: string = CRMScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.PARTITION)
export const GROUP_DEVICE_SCOPE_NAME: string = CRMScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.GROUP_DEVICE)

export const CRM_TYPE_SCOPE_NAME: string = NameSpacing(CONFIGURATION, ConfigurationTabFieldNames.CRM_TYPE)
export const CRM_OPTIONS_SCOPE_NAME: string = NameSpacing(CONFIGURATION, ConfigurationTabFieldNames.CRM_OPTIONS)
export const CRM_TEMPLATE_TYPE_SCOPE_NAME: string = NameSpacing(CONFIGURATION, ConfigurationTabFieldNames.TEMPLATE_TYPE)
